import { LocationMatchType } from 'app/enum';
import { MccMatchEnum } from 'app/enum/mcc-match-enum';

import { Channel } from '../constants';
import { MatchType } from '../constants/match-type';
import { localPreferenceManager } from '../utils/local-preference-manager';

export interface PatternData {
    cobrander?: string;
    opposingId?: string;
    matchOperator: MatchType;
    locationOperator: LocationMatchType;
    midPattern?: string;
    descPattern?: string;
    mccMatchOperator: MccMatchEnum;
    mccPattern: string[];
    cityPattern?: string;
    statePattern?: string;
    zipPattern?: string;
    countryPattern?: string;
    subChannel?: Channel;
    extractField?: string;
    extractPattern?: string;
}

/**
 * Constructs a default object of above instance.
 *
 * We do not want the above to be a class because this data comes from server and when it does it does not
 * get instantiated to a class, it only has the properties. So we have this factory method for constructing
 * fresh instances locally, when we need them.
 */
export const makePatternData = (): PatternData => ({
    matchOperator: localPreferenceManager.getPreferredMatchType(),
    locationOperator: localPreferenceManager.getPreferredLocationMatchType(),
    mccMatchOperator: MccMatchEnum.IN,
    mccPattern: [],
});
